import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { trpc } from '../lib/trpc';
import { useAuth } from '../lib/AuthContext';

/**
 * Route guard for admin-only pages
 * Checks if user is authenticated and has admin access
 */
export function AdminRoute() {
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // Query admin status
  const { data, isLoading: adminLoading } = trpc.admin.isAdmin.useQuery(undefined, {
    enabled: isAuthenticated,
    retry: false,
  });

  const isLoading = authLoading || (isAuthenticated && adminLoading);

  // Show loading spinner while checking
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
        role="status"
        aria-label="Checking admin access"
      >
        <CircularProgress size={48} aria-hidden="true" />
        <Typography variant="body2" color="text.secondary">
          Checking access...
        </Typography>
      </Box>
    );
  }

  // Redirect to monitors if not admin
  if (!data?.isAdmin) {
    return <Navigate to="/monitors" replace />;
  }

  // Render child routes if admin
  return <Outlet />;
}

export default AdminRoute;
